import { Fragment, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import ProfileAvatarTwo from "../Assets/ProfileAvatarTwo.png";
import CloseIcon from "../Assets/Icons/closeIcon.svg";
import UploadIcon from "../Assets/Icons/uploadIcon.svg";
import DatePicker from "./DatePicker";
import PlusIcon from "../Assets/Icons/plusWhite.svg";
import AiTeamDropDown from "./AiTeamDropDown";
import InfoIcon from "../Assets/Icons/infoIcon.svg";
import AvatarDropdown from "./AvatarDropdown";

export default function EditAiTaskModal({ open, setOpen, showProject }) {
  const [dialogOpen, setDialogOpen] = useState(false);

  const cancelButtonRef = useRef(null);

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform  rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-[42rem] sm:max-w-lg">
                <div className="bg-white px-5 pb-4 pt-4 sm:p-3 sm:pb-4 sm:px-5">
                  <div className="sm:flex sm:items-start sm:flex-col">
                    <div className="w-full">
                      <div className="flex items-center justify-between">
                        <p className="text-[1.1rem] text-[#111928] font-bold">
                          Edit Task
                        </p>
                        <div className="flex items-center">
                          <div className="relative">
                            <button
                              id="dropdownMenuIconHorizontalButton"
                              data-dropdown-toggle="dropdownDotsHorizontal"
                              className="inline-flex items-center text-sm p-2 font-medium text-center text-gray-900 bg-white rounded-lg border-none outline-none"
                              type="button"
                              onClick={() => setDialogOpen(!dialogOpen)}
                              onBlur={() => setDialogOpen(false)}
                            >
                              <svg
                                className="w-5 h-5"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="currentColor"
                                viewBox="0 0 16 3"
                              >
                                <path d="M2 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm6.041 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM14 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z" />
                              </svg>
                            </button>
                            {dialogOpen && (
                              <div
                                id="dropdownDots"
                                className="absolute z-50 top-10 mt-1 bg-white divide-y divide-gray-100 rounded-lg px-4 pt-4 pb-2 shadow w-[224px]"
                              >
                                <div>
                                  <div classname="flex flex-col ">
                                    <p className="text-[14px] text-[#6B7280]">
                                      Status
                                    </p>
                                    <div className="mt-1">
                                      <AiTeamDropDown
                                        text="In progress"
                                        width="195px"
                                      />
                                    </div>
                                  </div>
                                  <div className="h-[37px] flex items-center justify-start cursor-pointer">
                                    <p className="text-[14px] text-[#0E9F6E]">
                                      Mark as complete
                                    </p>
                                  </div>
                                  <div className="h-[37px] flex items-center justify-start cursor-pointer">
                                    <p className="text-[14px] text-[#F05252]">
                                      Delete
                                    </p>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                          <img
                            className="cursor-pointer ml-2"
                            onClick={() => setOpen(false)}
                            src={CloseIcon}
                          />
                        </div>
                      </div>
                      <div className="w-[100%] h-[1px] bg-[#E5E7EB] mt-2"></div>
                    </div>
                    <div className="w-full flex flex-col gap-3 mt-3">
                      <div className="flex items-start flex-col gap-1">
                        <label className="text-[0.95rem] text-[#111928] font-[500]">
                          Task Name
                        </label>
                        <input
                          className="w-[470px] h-[2.6rem] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px]"
                          type="text"
                          placeholder="Type task name"
                        />
                      </div>
                      <div className="flex items-center justify-between gap-x-3">
                        <div className="flex flex-col gap-1 w-full">
                          <label className="text-[0.95rem] text-[#111928] font-[500]">
                            Due Date
                          </label>
                          <DatePicker width="100%" />
                        </div>
                        {showProject && (
                          <div className="flex flex-col gap-1">
                            <label className="text-[0.95rem] text-[#111928] font-[500]">
                              Project
                            </label>
                            <AiTeamDropDown
                              text="Select project"
                              width="230px"
                            />
                          </div>
                        )}
                      </div>
                      {/* <div className="flex flex-col gap-1">
                        <label className="text-[0.95rem] text-[#111928] font-[500]">
                          Choose Individual Assignee
                        </label>
                        <AvatarDropdown width="470px" />
                      </div> */}
                      <div className="flex items-start flex-col gap-1">
                        <label className="text-[0.95rem] text-[#111928] font-[500]">
                          Task Description
                        </label>
                        <textarea
                          placeholder="Lorem ipsum dolor sit amet consectetur. Placerat augue luctus quam nulla in suspendisse. Ipsum tellus vitae ullamcorper ullamcorper ac tincidunt risus. Ut integer bibendum integer in sed dui. Fermentum proin eu morbi etiam non."
                          className="w-[470px] h-[170px] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px] pt-2 px-2 resize-none"
                        ></textarea>
                      </div>
                      <div>
                        <button className="w-[470px] h-[2.5rem] rounded-[8px] text-[0.90rem] text-white font-[500] border-[1px] border-[#942A27] bg-[#942A27]">
                          Save Changes
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
